module.exports = __webpack_public_path__ + "static/assets/1cf4253ddc736912846d6536a86efaa6.png";